import { BlendxCard } from '@blend-ed/blendx-ui';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { useMediaQuery } from '@openedx/paragon';
import React from 'react';
import messages from '../../../components/messages';

import { useCurrency } from '@blend-ed/blendx-platform/hooks';
import { useDiscoverPrograms } from '../../../hooks/programs/useFetchPrograms';

function TopPrograms({ curr_program_id, intl }) {

    const { discoverPrograms } = useDiscoverPrograms()
    const { symbol } = useCurrency()

    const topPrograms = discoverPrograms ? discoverPrograms.filter(program => program.id !== curr_program_id) : [];

    const isTablet = useMediaQuery({ query: '(min-width: 768px)' });

    if (topPrograms.length === 0) return null;

    return (
        <div className="program-single__popular-program">
            <h3 className='program-single__description-title'>{intl.formatMessage(messages.topProgramsTitle)}</h3>
            <div className='program-single__popular-program-cards-wrapper'>
                {topPrograms.slice(0, 3).map((program, index) => (
                    <BlendxCard
                        key={index}
                        title={program.name}
                        image={program.image}
                        estimatedTime={`${program.duration} ${isTablet ? program.durationMetric : program.durationMetric.slice(0, 1)}`}
                        totalCourses={`${program.programCoursesAggregate.agg_count} ${isTablet ? intl.formatMessage(messages.coursesLabel) : ''}`}
                        price={program.price}
                        type="price"
                        variant="program"
                        link={`/program/${program.id}`}
                        currency={symbol}
                    />
                ))}
            </div>
        </div>
    )
}

TopPrograms.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(TopPrograms)